<template>
  <div>
    <div
      class="m-4 mx-auto my-6 flex max-w-xl flex-col rounded-lg bg-white p-4"
    >
      <h1 class="text-lg font-normal">
        What brings you to The Virtual Gurus?
        <fa-icon
          class="text-vgorange pl-1 text-sm"
          icon="fa-regular fa-asterisk"
        />
      </h1>
      <v-radio-group
        ref="form"
        v-model="whyChooseUs"
        :error-messages="radioRules"
        density="comfortable"
      >
        <v-radio v-for="(item, index) of items" :key="index" :value="item">
          <template #label>
            <p class="pl-3 text-sm">{{ item }}</p>
          </template></v-radio
        >
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import { getConsultState } from '@/services/consultService';

export default {
  name: 'WhyChooseUs',
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update'],
  data() {
    return {
      whyChooseUs: '',
      items: [
        'My company or I need the help of one or more remote assistants',
        `I'd like to discuss a partnership opportunity`,
        `I'd like to become a remote assistant`,
      ],
    };
  },
  computed: {
    radioRules() {
      return this.error === true ? ['required'] : [];
    },
  },
  watch: {
    whyChooseUs() {
      this.$emit('update', {
        key: 'whyChooseUs',
        Q: 'What brings you to The Virtual Gurus?',
        A: this.whyChooseUs,
      });
    },
  },
  created() {
    this.whyChooseUs =
      getConsultState()?.questions?.find((item) => item.key === 'whyChooseUs')
        ?.A || '';
  },
};
</script>

<style scoped></style>
